'use client';

import dynamic from 'next/dynamic';
import { usePageReady } from '@/lib/late-widgets';

// The compare tray, loaded once the page is ready (lib/late-widgets.ts): it
// shows only what the visitor saved on this device, so there is nothing to
// render before then anyway.
const FloatingCompareBar = dynamic(() => import('./FloatingCompareBar'), { ssr: false });

export default function LateCompareBar(props: { lang: string; hideOnPhone?: boolean }) {
  return usePageReady() ? <FloatingCompareBar {...props} /> : null;
}
